import { AlertTriangle, RotateCcw } from "lucide-react";

export function AIResponseRetry({
  onRetry,
  disabled,
}: {
  onRetry: () => void;
  disabled: boolean;
}) {
  return (
    <div className="flex gap-2.5">
      <span className="grid h-7 w-7 flex-shrink-0 place-items-center rounded-full border border-border bg-surface-2 text-text-muted">
        <AlertTriangle className="h-3.5 w-3.5" />
      </span>
      <div className="flex items-center gap-2 rounded-2xl rounded-tl-sm border border-border bg-surface-2 px-3.5 py-2.5 text-sm text-text-muted">
        <span>Couldn't respond.</span>
        <button
          type="button"
          onClick={onRetry}
          disabled={disabled}
          className="inline-flex items-center gap-1 font-medium text-brand hover:underline disabled:opacity-50"
        >
          <RotateCcw className="h-3.5 w-3.5" />
          Retry
        </button>
      </div>
    </div>
  );
}
